import { css } from '@betterment/samba-styled-system/css';
import { SystemStyleObject } from '@betterment/samba-styled-system/types';
import * as ToggleGroupPrimitive from '@radix-ui/react-toggle-group';
import { type ToggleGroupItemProps, type ToggleGroupSingleProps } from '@radix-ui/react-toggle-group';

type BaseCssProp = { css?: SystemStyleObject };

type RootProps = Omit<ToggleGroupSingleProps, 'type'> & BaseCssProp;

const rootStyles = css.raw({
  display: 'flex',
  gap: 'space.100',
  alignItems: 'center',
  alignSelf: 'center',
});

const Root: React.FC<RootProps> = ({ css: cssProp, children, ...props }) => {
  return (
    <ToggleGroupPrimitive.Root
      data-samba-component={true}
      type="single"
      className={css(rootStyles, cssProp)}
      {...props}
    >
      {children}
    </ToggleGroupPrimitive.Root>
  );
};

type ItemProps = ToggleGroupItemProps & BaseCssProp;

const itemStyles = css.raw({
  border: 'unset',
  px: 'space.150',
  py: 'space.25',
  bg: 'background.transparent',
  color: 'text',
  borderRadius: 'medium',
  cursor: 'pointer',
  textStyle: 'text50',
  textDecoration: 'none',
  fontVariantNumeric: 'tabular-nums',
  minWidth: '42px',
  transition: 'background-color 0.1s ease-in-out',
  '&[data-state=on]': {
    bg: 'background.primary',
    color: 'text.onPrimary',
  },
  '&[data-state=on]:hover': {
    bg: 'background.primary.hover',
  },
  '&[data-state=off]:hover': {
    bg: 'background.transparent.hover',
  },
  _focusVisible: {
    outline: 'token(borderWidths.thick) solid token(colors.border.focused)',
    outlineOffset: '1px',
  },
});

const Item: React.FC<ItemProps> = ({ css: cssProp, children, ...props }) => {
  return (
    <ToggleGroupPrimitive.Item data-samba-component={true} className={css(itemStyles, cssProp)} {...props}>
      {children}
    </ToggleGroupPrimitive.Item>
  );
};

export const DateOptionToggleGroup = Object.assign(Root, { Item });

DateOptionToggleGroup.displayName = 'DateOptionToggleGroup';
DateOptionToggleGroup.Item.displayName = 'DateOptionToggleGroup.Item';
